import type { ColumnsType } from 'antd/es/table';

import type { ServiceTicketTableData } from '../../types';

type ActionColRenderer = ColumnsType<ServiceTicketTableData>[0]['render'];

export const getServiceTicketTableColumns = (
  actionColRenderer: ActionColRenderer
) => {
  const columns: ColumnsType<ServiceTicketTableData> = [
    {
      title: '服務',
      dataIndex: 'serviceName',
    },
    {
      title: '票卷功能開/關',
      dataIndex: 'isActive',
      render: (value) => (value ? '開' : '關'),
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 100,
      fixed: 'right',
      render: actionColRenderer,
    },
  ];
  return columns;
};
